// src/pages/DefinitionPage.js
import React from 'react';
import DefinitionText from '../components/DefinitionText';

const DefinitionPage = ({ selectedCompany, selectedQuarter, metricsData }) => {
  return (
    <div className="w-full">
      <DefinitionText
        selectedCompany={selectedCompany}
        selectedQuarter={selectedQuarter}
        // if you later want to pass a dynamic map instead of placeholders:
        // definitions={metricsData?.definitions}
      />
    </div>
  );
};

export default DefinitionPage;


